module.exports = __webpack_public_path__ + "img/subscription-review.890d5ab5.png";